type ItemCardProps = {
  link?: string;
  img?: string;
  children: React.HTMLAttributes<HTMLElement>;
};

const ItemCard: React.FC<ItemCardProps> = ({ link, img, children }) => {
  if (link) {
    return (
      <a className='text-dark d-block' href={link} target='_blank'>
        <div className='d-inline-block'>
          {img ? (
            <img width={50} height={50} className='img-fluid' src={img} />
          ) : null}
        </div>
        {children}
      </a>
    );
  } else {
    return (
      <div>
        <div className='d-inline-block'>
          {img ? (
            <img
              width={50}
              height={50}
              alt={`foto de ${children}`}
              className='img-fluid'
              src={img}
            />
          ) : null}
        </div>
        <label>{children}</label>
      </div>
    );
  }
};

export default ItemCard;
